export const tileRowGap = 5;

export const priceValuePropBackground = '#809054';

// Aspect for tiles that display a price label (PDP "related items", cart sections).
export const desktopAspect = '3 / 5';
export const mobileAspect = '1 / 2';

// Aspect for gallery tiles, which don't show a price label — slightly shorter so the row
// isn't padded by the space a price label would have occupied.
export const galleryDesktopAspectX = '3.15';
export const galleryDesktopAspectY = '4.5';
export const galleryDesktopAspect = `${galleryDesktopAspectX} / ${galleryDesktopAspectY}`;

export const galleryMobileAspectX = '1.05';
export const galleryMobileAspectY = '1.8';
export const galleryMobileAspect = `${galleryMobileAspectX} / ${galleryMobileAspectY}`;
